<template>
  <div id="class_item">
    <div class="con_all" v-if="!$route.meta.keepAliveSub2">
      <div class="con_box2">
        <div class="ca_title">
          <div class="ca_l">
            <span class="con_title con_title_line">{{showName()}}</span>
          </div>
          <div class="ca_l">
            <div class="ca_r">
              <router-link :to="{ name: 'coach_info', params:{classname: showName()}}">
                <button class="ca_btn">{{showPage.coach_info}}</button>
              </router-link>
            </div>
            <div class="ca_r2">
              <router-link :to="{ name: 'facility', params:{classname: showName()}}">
                <button class="ca_btn">{{showPage.facility}}</button>
              </router-link>
            </div>
            <div class="ca_r2">
              <router-link :to="{ name: 'class_inside', params:{classname: showName()}}">
                <button class="ca_btn">{{showPage.class_inside}}</button>
              </router-link>
            </div>
            <div class="fix"></div>
          </div>
          <div class="fix"></div>
        </div>
        <div class="team_bbox" v-html="showIntroduction()">
        </div>
        <span class="con_title con_title_line">{{showPage.apply_class}}</span>
        <div class="cla_box mt20" v-for="(admission,index) in admissions" :key="index">
          <div class="cla_l">{{classTypeName(admission)}}</div>
          <div class="cla_l">{{admission.memberType}}</div>
          <div class="cla_l" v-if="admission.type === 2">{{memberRange(admission)}}{{showPage.people}}</div>
          <div class="cla_l">{{admission.classHour}}</div>
          <div class="cla_r">
            <button type="submit" class="ca2_btn" @click="signUp(admission.id)">{{showPage.signup}}</button>
          </div>
          <div class="fix"></div>
        </div>
        <div class="team_bbox mt30" v-html="showNote()">
        </div>
      </div>
    </div>
    <router-view :classitem="classitem" v-if="$route.meta.keepAliveSub2"></router-view>
  </div>
</template>
<script>
import axios from 'axios';
import { API, Message, ShowPage } from '@/assets/project_setting/config';
import { GetErrorHandler, ShowMessage } from '@/assets/library/axiosErrorHandler';

export default {
  name: 'class_item',
  props: ['classitem'],
  data() {
    return {
      classId: this.$route.params.classid,
      admissions: [],
      showPage: ShowPage(sessionStorage.getItem('locale')),
      className: '',
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.initAdmissions()
      this.initParentClass();
    },
    initParentClass() {
      if (!this.classitem) {
        this.getClassData();
      }
    },
    initAdmissions() {
      this.getAdmissionsData();
    },
    getClassData() {
      axios.get(API.class + `?id=${this.classId}`)
        .then(response => {
          this.$emit('initClass', response.data);
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    getAdmissionsData() {
      axios.get(API.classadmissions + `?classId=${this.classId}`)
        .then(response => {
          this.admissions = response.data;
          this.handleReceivedAdmissions();
        })
        .catch(error => {
          GetErrorHandler.bind(this)(error);
        });
    },
    handleReceivedAdmissions() {
      this.admissions.forEach(admission => {
        try {
          admission.memberType = JSON.parse(admission.memberType);
          admission.memberType = admission.memberType.map(el => {
            if (sessionStorage.locale === 'CH')
              return el == 1 ? '成人' : '兒童';
            else
              return el == 1 ? 'Adult' : 'Child';
          }).toString().replace(',', '/');
        } catch (error) {}
      }, this);
    },
    signUp(id) {
      this.$router.push({ name: 'class_sign', params: { classname: this.showName(), admissionsid: id } });
    },
    classTypeName(admission) {
      if (sessionStorage.locale === 'CH') {
        let level = ['', '初階', '進階', '矯正'],
          maxPersonal = ['零', '一', '二', '三', '四', '五'];
        if (admission.type === 1) {
          return admission.maxPersonal + level[admission.classLevel] + '班';
        } else if (admission.type === 2) {
          return '團體' + level[admission.classLevel] + '班';
        }
      } else {
        let level = ['', 'Beginner', 'Advanced', 'Correction'],
          maxPersonal = ['zero', 'one', 'two', 'three', 'four', 'five'];
        if (admission.type === 1) {
          return admission.maxPersonal + ' ' + level[admission.classLevel] + ' class';
        } else if (admission.type === 2) {
          return 'Group ' + level[admission.classLevel] + ' Class';
        }
      }
    },


    showName() {
      return sessionStorage.locale === 'CH' ? this.classitem.nameCh : this.classitem.nameEn;
    },
    showIntroduction() {
      return sessionStorage.locale === 'CH' ? (this.classitem.introductionCh) : (this.classitem.introductionEn);
    },
    showNote() {
      return sessionStorage.locale === 'CH' ? (this.classitem.noteCh) : (this.classitem.noteEn);
    },
    memberRange(admission) {
      if (admission.minMember == admission.maxMember) {
        return admission.maxMember
      } else {
        return admission.minMember + '~' + admission.maxMember
      }
    }
  },
}

</script>
<style lang="scss">
#class_item {
  .cla_box {
    width: 100%;
    background: red;
    padding: 15px 20px;
    margin-top: 40px;
    border-radius: 3px;
    background: -webkit-linear-gradient(0deg, #E7E7E7, #fff);
    background: linear-gradient(0deg, #E7E7E7, #fff);
    border: 1px solid #E2E2E2;
    border-bottom: 1px solid #A2A2A2;
  }
}

</style>



// WEBPACK FOOTER //
// ClassItem.vue?2dad4394